import { useContext } from 'react'

import VasEntryPointsContext from './VasEntryPointsContext'

function useVasEntryPointsContext() {
  return useContext(VasEntryPointsContext)
}

export default useVasEntryPointsContext
